import { useMemo } from 'react';
import { t } from 'i18next';
import { TypesStatsResponse } from '../../../shared/models/monitor/data/sources/TypesStatsResponse';
import { getMonitorName } from '../../../shared/helpers/MonitorTypeHelpers';

export const useTypesShareHorizontalMatrix = (
  typesStats: TypesStatsResponse | undefined
): string[][] => {
  return useMemo(() => {
    const stats = typesStats?.types ?? [];

    const order: string[] = [];
    const countsByName = new Map<string, number>();

    for (const item of stats) {
      const name = getMonitorName(item.type);
      if (!name) continue;
      if (!countsByName.has(name)) {
        countsByName.set(name, 0);
        order.push(name);
      }
      countsByName.set(name, (countsByName.get(name) || 0) + (item.count || 0));
    }

    const total = Array.from(countsByName.values()).reduce((acc, v) => acc + v, 0);

    const matrix: (string | number)[][] = [[t('typeColumn'), '%']];
    for (const name of order) {
      const count = countsByName.get(name) || 0;
      const pct = total > 0 ? Math.round((count / total) * 10000) / 100 : 0; // 2 decimals
      matrix.push([name, pct]);
    }

    return matrix as unknown as string[][];
  }, [typesStats?.types]);
};


